var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.loaded)?_vm._t("default"):_vm._e(),(_vm.failed)?_c('div',{staticClass:"error"},[_c('page-load-error',{on:{"reload":_vm.onReload}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }